import { render, staticRenderFns } from "./VehicleTab.vue?vue&type=template&id=7306bf0f&scoped=true"
import script from "./VehicleTab.vue?vue&type=script&lang=js"
export * from "./VehicleTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7306bf0f",
  null
  
)

export default component.exports